<div class="in-out-filter">
  <button (click)="addFilter('direction', null)"
          class="in-out-filter-all"
          [class.active]="!filters.direction" translate>ALL</button>
  <button (click)="addFilter('direction', 'INBOUND')"
          class="in-out-filter-incoming"
          [class.active]="filters.direction === 'INBOUND'" translate>INCOMING</button>
  <button (click)="addFilter('direction', 'OUTBOUND')"
          class="in-out-filter-outgoing"
          [class.active]="filters.direction === 'OUTBOUND'" translate>OUTGOING</button>
</div>
